/**
 * 签署成功：通知宿主（小程序/App）并返回上一页。
 * 微信规则：postMessage 仅在 web-view 后退/销毁时投递给 @message，因此必须主动 navigateBack。
 */

function getUniBridge() {
  if (typeof window === 'undefined') return null
  return window.uni || null
}

function getWxMiniProgram() {
  if (typeof window === 'undefined') return null
  const wxObj = window.wx
  return wxObj && wxObj.miniProgram ? wxObj.miniProgram : null
}

export function notifyHostSignSuccess(message = '签署成功') {
  const payload = {
    action: 'sign_success',
    message,
  }

  // uni-app web-view SDK（由 uni-webview-lib / 宿主注入到 window.uni）
  try {
    const uniBridge = getUniBridge()
    if (uniBridge && typeof uniBridge.postMessage === 'function') {
      uniBridge.postMessage({ data: payload })
    }
  } catch (e) {
    console.warn('[sign] uni.postMessage fail', e)
  }

  // 微信 JSSDK 兜底
  try {
    const miniProgram = getWxMiniProgram()
    if (miniProgram && typeof miniProgram.postMessage === 'function') {
      miniProgram.postMessage({ data: payload })
    }
  } catch (e) {
    console.warn('[sign] wx.miniProgram.postMessage fail', e)
  }

  // 延迟后退，确保 postMessage 已入队
  setTimeout(() => {
    navigateBackToHost()
  }, 280)
}

function navigateBackToHost() {
  try {
    const uniBridge = getUniBridge()
    if (uniBridge) {
      if (uniBridge.webView && typeof uniBridge.webView.navigateBack === 'function') {
        uniBridge.webView.navigateBack({ delta: 1 })
        return
      }
      if (typeof uniBridge.navigateBack === 'function') {
        uniBridge.navigateBack({ delta: 1 })
        return
      }
    }
  } catch (e) {
    console.warn('[sign] uni.navigateBack fail', e)
  }

  try {
    const miniProgram = getWxMiniProgram()
    if (miniProgram && typeof miniProgram.navigateBack === 'function') {
      miniProgram.navigateBack({ delta: 1 })
      return
    }
  } catch (e) {
    console.warn('[sign] wx.miniProgram.navigateBack fail', e)
  }

  // 浏览器直开调试
  try {
    if (typeof window !== 'undefined' && window.history.length > 1) {
      window.history.back()
    }
  } catch (e) {
    /* ignore */
  }
}
